import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { createStructuredSelector } from "reselect"
import moment from 'moment'

import { withClientId } from "hocs"
import { blocksSelector, detectablesSheduleBlockLoadingSelector } from "redux/selectors"
import { bem, comparePropertiesGraded } from "utils/helpers"

import { Table } from 'elements'

import "./index.scss"

const em = (e, m) => bem("blocks-list", e, m)

const formatTime = (dateTime)=> moment(dateTime).format('DD/MM/YYYY HH:mm')

class BlocksList extends Component {

  columns = () => {
    const { rowCallback } = this.props
    return [
      {
        title: "Name",
        dataIndex: "name",
        render: (text, record) => (
          <a onClick={(e) => {
            e.preventDefault()
            rowCallback(record.blockId)
          }}>
            {text}
          </a>
        ),
        sorter: (a, b) => comparePropertiesGraded(a, b, "name")
      },
      {
        title: "Start",
        dataIndex: "startTime",
        render: formatTime,
        sorter: (a, b) => comparePropertiesGraded(a, b, "startTime", "endTime")
      },
      {
        title: "End",
        dataIndex: "endTime",
        render: formatTime,
        sorter: (a, b) => comparePropertiesGraded(a, b, "endTime", "startTime")
      },
      {
        title: "Site",
        dataIndex: "siteDescription",
        sorter: (a, b) => comparePropertiesGraded(a, b, "siteDescription", "zoneName")
      },
      {
        title: "Zone",
        dataIndex: "zoneName",
        sorter: (a, b) => comparePropertiesGraded(a, b, "zoneName", "siteDescription")
      }
    ]
  }

  render = () => {
    const { loading, blocks } = this.props
    const dataSource = blocks.sort((a, b) => comparePropertiesGraded(a, b, "startTime", "endTime", "name", "siteDescription", "zoneName"))
    return <Table
      className={em("table")}
      dataSource={dataSource}
      columns={this.columns()}
      pagination={false}
      rowKey={(record)=>record.blockId}
      loading={loading}
    />
  }

}

export const selectors = createStructuredSelector({
  blocks: blocksSelector,
  loading: detectablesSheduleBlockLoadingSelector,
})

export default compose(
  withClientId,
  connect(selectors),
)(BlocksList)



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-schedule-detail/components/blocks-list/index.js